import * as React from 'react';

import styled, { css } from 'styled-components';

import { motion } from 'framer-motion';
import { rgba } from 'polished';

export interface RightArrowIconProps {
  className?: string;
  disabled?: boolean;
  isWhite?: boolean;
  direction?: 'right' | 'left';
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const RightArrowIcon: React.FC<RightArrowIconProps> = (props) => {
  const iconMotion = {
    rest: { x: 0, scale: 1 },
    hover: { x: props.direction === 'left' ? 2 : -2, scale: 1.0625 },
    tap: { x: props.direction === 'left' ? 100 : -100, scale: 0.95 },
  };

  return (
    <motion.svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      initial="rest"
      whileHover={props.disabled ? 'rest' : 'hover'}
      whileTap={props.disabled ? 'rest' : 'tap'}
      animate="rest"
      onClick={(ev) => (props.onClick ? props.onClick(ev) : null)}
    >
      <Arrow
        disabled={props.disabled}
        variants={iconMotion}
        className={props.isWhite ? 'white' : ''}
        d={
          props.direction === 'left'
            ? 'M6.3 1.8L3.5 4.9 12 5c0.3 0 0.5 0.1 0.7 0.3C12.9 5.5 13 5.7 13 6c0 0.3-0.1 0.6-0.3 0.8C12.5 7 12.3 7.1 12 7.1l-8.5 0 2.8 3.1c0.2 0.2 0.3 0.5 0.3 0.8 0 0.3-0.1 0.6-0.3 0.8 -0.4 0.4-1 0.4-1.4 0L0.2 6.6c-0.3-0.3-0.3-0.9 0-1.3l4.7-5c0.4-0.4 1-0.4 1.4 0 0.2 0.2 0.3 0.5 0.3 0.8C6.6 1.4 6.5 1.6 6.3 1.8z'
            : 'M6.7 1.8l2.9 3.1L1 5C0.7 5 0.5 5.1 0.3 5.3 0.1 5.5 0 5.7 0 6c0 0.3 0.1 0.6 0.3 0.8C0.5 7 0.7 7.1 1 7.1l8.5 0 -2.8 3.1c-0.2 0.2-0.3 0.5-0.3 0.8 0 0.3 0.1 0.6 0.3 0.8 0.4 0.4 1 0.4 1.4 0l4.6-5.1c0.3-0.3 0.3-0.9 0-1.3l-4.7-5c-0.4-0.4-1-0.4-1.4 0C6.5 0.5 6.4 0.8 6.4 1.1 6.4 1.4 6.5 1.6 6.7 1.8z'
        }
      />
    </motion.svg>
  );
};

export default styled(RightArrowIcon)`
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};

  path {
    transition: fill
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  }
`;

const Arrow = styled(motion.path)<{ disabled?: boolean }>`
  ${({ disabled }) =>
    disabled
      ? css`
          fill: ${({ theme }) => rgba(theme.colors.black, 0.5)};
          &.white {
            fill: ${({ theme }) => rgba(theme.colors.white, 0.5)};
          }
        `
      : css`
          fill: ${({ theme }) => theme.colors.primary};
          &.white {
            fill: ${({ theme }) => theme.colors.white};
          }
        `}
`;
